import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { DateAdapter } from '@angular/material/core';
import { enUS } from 'date-fns/locale';

bootstrapApplication(AppComponent, appConfig)
  .then(appRef => {
    // Inject DateAdapter and set locale to guarantee parsing in the same locale
    const dateAdapter = appRef.injector.get(DateAdapter);
    dateAdapter.setLocale(enUS);
  })
  .catch((err) => console.error(err));
